import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * `cn` — the shadcn/ui class-name helper.
 *
 * Combines `clsx` (conditional class composition) with `tailwind-merge`
 * (which resolves conflicting Tailwind utilities so the LAST one wins).
 * Without `twMerge`, `cn('px-2', 'px-4')` would emit both classes and
 * the result would depend on stylesheet order; with it, `px-4` wins.
 *
 * Every shadcn primitive and every CORTEX component built on top of
 * them uses this to merge a base class set with caller overrides.
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
